import { Route, Routes } from 'react-router-dom'
import { Payment } from 'components'
import { NotFound, Success } from 'primsell-shared-layer/components'

import routes from './routes'
import { SecondaryLayout } from 'primsell-shared-layer/components'

export const AppRouter = (): JSX.Element => {
  return (
    <SecondaryLayout>
      <Routes>
        <Route path={routes.ROUTE_PAYMENT} element={<Payment />} />
        <Route path={routes.ROUTE_NOT_FOUND} element={<NotFound />} />
        <Route path={routes.ROUTE_SUCCESS} element={<Success text="Your payment is successful." />} />
      </Routes>
    </SecondaryLayout>
  )
}
